export const LOCATION_LOAD_SUCCESS = 'location/LOAD_SUCCESS';
export const LOCATION_EDIT_SUCCESS = 'location/EDIT_SUCCESS';
export const LOCATION_CREATE_SUCCESS = 'location/CREATE_SUCCESS';
export const LOCATION_DELETE_SUCCESS = 'location/DELETE_SUCCESS';
export const SET_BUSY = 'location/SET_BUSY';
export const UNSET_BUSY = 'location/UNSET_BUSY';
